module.exports = __webpack_public_path__ + "img/seckill@2x.2bd103c2.png";